export default __webpack_public_path__ + "images/23445899a89f4fa7212998d333337a8a-no_image_nearby_poi.svg";